import { TButtonTheme } from '@cian/ui-kit/button/types';
import * as React from 'react';
import { useEffectOnce } from '../../../../hooks/useEffectOnce';

import { FinalStepQuestionLayout } from '../../components';
import { useSetOfferLabel, useE2eLabelTracking } from '../../hooks';
import { EContainerTypes } from '../../types';
import { FormContext } from '../../utils/formContext';
import { trackLabelAddedScreenShow, trackRemoveLabelClick } from '../../utils/tracking';

export const LabelAddedContainer: React.FC = () => {
  const formContext = React.useContext(FormContext);
  const onTrackLabelAddedScreenShow = useE2eLabelTracking(trackLabelAddedScreenShow);
  const onTrackRemoveLabelClick = useE2eLabelTracking(trackRemoveLabelClick);
  useEffectOnce(() => onTrackLabelAddedScreenShow({}));

  const { isLoading, isError, setOfferLabel } = useSetOfferLabel({
    showLabel: false,
    onSuccess: () => {
      onTrackRemoveLabelClick({});
      if (formContext.previousStep === EContainerTypes.AddLabelWithoutProfiling) {
        formContext.onPreviousStep();
      } else {
        /* istanbul ignore next */
        formContext.onStepYes?.();
      }
    },
  });

  return (
    <FinalStepQuestionLayout
      onButtonClick={setOfferLabel}
      isLoading={isLoading}
      isError={isError}
      changeLabelButtonText="Убрать значок"
      changeLabelButtonTheme={'fill_secondary' as TButtonTheme}
    />
  );
};
